<ng-progress />
<section class="onBoard">
  <div class="user-info">
    <span class="user-email">{{ userData?.user.email }}</span>
    <a (click)="signOut()" class="logout-link">Logout</a>
  </div>
  <div class="container">
    <div class="scrollWrap">
      <div *ngIf="currentStep > 1" class="boradLogo text-center">
        <img src="assets/images/logo/confe-light-web.svg" alt="" />
      </div>

      <!--  <app-onboarding-user-question
        (moveToCertainStep)="moveToCertainStep($event)"
        *ngIf="currentStep === 0"
      />-->
      <app-onboarding-steps-pagination
        [activeIndex]="currentStep - 3"
        *ngIf="currentStep > 3 && currentStep < 5"
      />
      <app-onboarding-timestamp (nextStep)="nextStep($event)" *ngIf="currentStep === 1" />
      <app-onboarding-step-one (nextStep)="nextStep($event)" *ngIf="currentStep === 2" />
      <app-onboarding-step-two (nextStep)="nextStep($event)" *ngIf="currentStep === 3" />
      @if (userData?.workspaces[0]) {
        <app-onboarding-step-four
          [workspaceDetails]="userData?.workspaces[0]"
          (nextStep)="nextStep($event)"
          *ngIf="currentStep === 4"
        />
      }
      <!--<app-onboarding-step-five
        [workspaceDetails]="userData?.workspaces[0]"
        *ngIf="currentStep === 5"
      />-->
      <div *ngIf="currentStep" class="highlight-message">
        Need help? <strong (click)="openCalendly()">Book a call.</strong>
      </div>
    </div>

    <!-- ✅ Highlighted message at bottom -->
  </div>
</section>
